import { faClock, faUsers, faUserTie, faBuilding, faFileAlt, faXmarkCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react'
import { Tabs, Tab, Button, Form, Row, Col } from 'react-bootstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import OperatorTable from '../../../../../components/table/Operator.table';
import CenterDataV2 from '../CenterDataV2';
import ReverificationDetails from '../ReverificationDetails';
import toast from 'react-hot-toast';
import AdminService from '../../../../../services/admin.service';
import ConfirmModal from '../../../../../components/Modal/Confirm.modal';
import DatePicker from "react-datepicker"
import moment from 'moment';
import ExamShifts from './ExamShifts';
import ExamClients from './ExamClients';


interface IProps {
    exam: any;
    refreshExam: () => void
}


export default function ExamDetails({ exam, refreshExam }: IProps) {

    const params = useParams();

    const [activeTab, setActiveTab] = useState<string>("shifts");
    const [showCreateOperator, setShowCreteOperator] = useState<boolean>(false);
    const [newOperatorEmail, setNewOperatorEmail] = useState<string>("");
    const [newUserName, setnewUserName] = useState<string>("");
    const [data, setData] = useState<any>(null);
    const [collegeName, setCollegeName] = useState<string>("");
    const [collegeId, setCollegeId] = useState<string>("");
    const [operators, setOperators] = useState<any>();
    const [serachParams, setSearchParams] = useSearchParams();


    function handleChangeData(e: any) {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const handleCreateOperator = async () => {
        if (!newOperatorEmail || !newUserName || !data?.startTime || !data?.endTime || !collegeName || !collegeId) {
            toast.error("All fields are required");
            return;
        }
        await AdminService.createOperator(params.examId, {

            emailId: newOperatorEmail,
            userName: newUserName,
            accessStartTime: data.startTime,
            accessEndTime: data.endTime,
            examId: params.examId,
            collegeName: collegeName,
            collegId: collegeId,
            // stream: stream
        })
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Opertro created successfully");
                    getAllOperators();
                    setShowCreteOperator(false);

                    setNewOperatorEmail("");
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Unable to creaet Opertaor");
            });
    };

    const getAllOperators = async () => {
        await AdminService.getAllOperatoprs(params.examId).then((res) => {
            if (res.status === 200) {
                console.log(res.data);
                setOperators(res?.data?.data?.operators || []);
            }
        });
    };

    useEffect(() => {
        if (activeTab === 'operators') {
            getAllOperators();
        }
    }, []);

    useEffect(() => {
        setSearchParams({ tab: activeTab });
    }, [activeTab]);

    useEffect(() => {
        setActiveTab(serachParams.get('tab') || 'shifts');
    }, []);

    return (
        <>
            <div
                style={{
                    width: "100%",
                    minHeight: 500,
                    paddingLeft: "30px",
                    borderLeft: "1px solid #cccccc",
                }}
            >
                <div className="mb-4">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k || "shifts")}
                        className="mb-0 mt-2"
                    // variant="pills"
                    >
                        <Tab
                            eventKey="shifts"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faClock} className="me-2" />
                                    Shifts
                                </span>
                            }
                        >
                            {
                                activeTab == 'shifts' &&
                                <ExamShifts exam={exam} refreshExam={refreshExam} />
                            }
                        </Tab>

                        <Tab
                            eventKey="clients"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faUsers} className="me-2" />
                                    Clients
                                </span>
                            }
                        >
                            {
                                activeTab == 'clients' &&
                                <ExamClients />
                            }
                        </Tab>

                        <Tab
                            eventKey="centers"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faBuilding} className="me-2" />
                                    Center Operators
                                </span>
                            }
                        >
                            {
                                activeTab == 'centers' &&
                                <div className="mt-3">
                                    <CenterDataV2 examId={params?.examId} />
                                </div>
                            }
                        </Tab>

                        <Tab
                            eventKey="operators"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faUserTie} className="me-2" />
                                    Re-Verification Operator
                                </span>
                            }
                        >
                            {
                                activeTab == 'operators' &&
                                <div className="mt-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p
                                            style={{ fontSize: "18px", fontWeight: "bold" }}
                                            className="mt-2"
                                        >
                                            Re-Verification Operator
                                        </p>
                                        <Button
                                            variant="outline-primary"
                                            className="fw-bold"
                                            size="sm"
                                            onClick={() => setShowCreteOperator(true)}
                                        >
                                            create-operator
                                        </Button>
                                    </div>
                                    <div>
                                        <OperatorTable
                                            operators={operators}
                                            examId={params.examId}
                                            reload={getAllOperators}
                                        />
                                    </div>
                                </div>
                            }
                        </Tab>

                        <Tab
                            eventKey="reverification"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                    Reverification Details
                                </span>
                            }
                        >
                            {
                                activeTab == "reverification" &&
                                <div className="mt-3">
                                    <ReverificationDetails examId={params?.examId} />
                                </div>
                            }
                        </Tab>
                    </Tabs>
                </div>
            </div >

            <ConfirmModal
                titleText={"Create operator modal"}
                size="lg"
                bodyText={
                    <>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <label className="fw-bold xcn-text-12 text-secondary">
                                Operator Username
                            </label>
                            <Form.Control
                                type="userName"
                                value={newUserName}
                                onChange={(e: any) => setnewUserName(e.target.value)}
                            />
                        </Form.Group>


                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <label className="fw-bold xcn-text-12 text-secondary">
                                Operator Email
                            </label>
                            <Form.Control
                                type="email"
                                value={newOperatorEmail}
                                onChange={(e: any) => setNewOperatorEmail(e.target.value)}

                            />

                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <label className="fw-bold xcn-text-12 text-secondary">
                                College Name
                            </label>
                            <Form.Control
                                type="text"
                                value={collegeName}
                                onChange={(e: any) => setCollegeName(e.target.value)}

                            />
                        </Form.Group>

                        <Row>
                            <Col>

                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <label className="fw-bold xcn-text-12 text-secondary">
                                        College ID
                                    </label>
                                    <Form.Control
                                        type="text"
                                        value={collegeId}
                                        onChange={(e: any) => setCollegeId(e.target.value)}

                                    />

                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col md>
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    Start Time
                                </label>
                                <DatePicker
                                    dateFormat="yyyy/MM/dd h:mm aa"
                                    showTimeSelect
                                    selected={moment(data?.startTime).toDate()}
                                    name="startTime"
                                    onChange={(e) => {
                                        handleChangeData({
                                            target: { name: "startTime", value: e },
                                        });
                                    }}
                                    className="form-control xcn-text-12"
                                    minDate={new Date()}
                                />
                            </Col>
                            <Col md>
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    End Time
                                </label>
                                <DatePicker
                                    dateFormat="yyyy/MM/dd h:mm aa"
                                    showTimeSelect
                                    name="endTime"
                                    selected={moment(data?.endTime).toDate()}
                                    onChange={(e) => {
                                        handleChangeData({
                                            target: { name: "endTime", value: e },
                                        });
                                    }}
                                    className="form-control xcn-text-12"
                                    minDate={new Date()}
                                />
                            </Col>
                        </Row>
                    </>
                }
                show={showCreateOperator}
                onHide={() => setShowCreteOperator(false)}
                button={[
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
                            </>
                        ),
                        action: () => setShowCreteOperator(false),
                        variant: "secondary",
                    },
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faCheck} /> Create
                            </>
                        ),
                        action: handleCreateOperator,
                        variant: "success",
                    },
                ]}
            />
        </>
    )
}